import React from 'react'
import { Answer } from '../index.js'
import styles from "./style.module.scss"
import { QuestionState } from "../../pages/Quiz/types"

interface props {
   index: number,
   q: QuestionState,
   checkAnswer: Function,
   userAnswer: string | undefined
}

const Question: React.FC<props> = ({ index, q, checkAnswer, userAnswer }) => {

   const className = (a: string): string => userAnswer ?
      a === q.correct_answer ? "right" :
         userAnswer === a ? "false" :
            "disable" : ""

   return (
      <div className={`${styles.questionCard} d-flex`}>
         <h4> question number:  {index + 1}  </h4>
         <p dangerouslySetInnerHTML={{ __html: q.question }} />
         <div className={`${styles.answers} d-flex btnbox`}>
            {q.answers.map((a: string, i: number) =>
               <Answer
                  className={className(a)}
                  key={`a${i}`}
                  text={a}
                  checkAnswer={checkAnswer}
                  disable={!!userAnswer} />
            )}
         </div>
      </div>
   )
}

export default Question